import React, { Component } from 'react';
import NumberFormat from 'components/NumberFormat';
import './Package.scss';

const Package = ({ p, installmentPrice }) => {
    if (p) {
        return (
            <div className="Grid Grid-cell Package">
                <div className="Grid-column Grid-cell">
                    <div className="title">
                        {/*Pacote*/}
                    </div>
                    <div className="value">
                        <div className="price">
                            {(!!p.priceWithDiscount) ?
                                <div>
                                    <span className="adventure-old-price">
                                        <span className="discount-box">
                                            <NumberFormat value={(p.priceWithDiscount * 100 / p.price) - 100} />%
                                        </span>
                                        <span className="currency">
                                            R$
                                    </span> <NumberFormat value={p.price} />
                                    </span>
                                    <span className="currency">
                                        R$
                                    </span> <NumberFormat value={p.priceWithDiscount} />
                                    {/* <span className="person"> por pessoa</span> */}
                                </div>
                                :
                                <div>
                                    <span className="currency">
                                        R$
                                    </span> <NumberFormat value={p.price} />
                                    {/* <span className="person"> por pessoa</span> */}
                                </div>
                            }
                        </div>
                        {/* <div className="installment">
                            ou em até 12x de R$ <NumberFormat value={installmentPrice} />
                        </div> */}

                    </div>
                </div>
            </div>
        );
    } else {
        return (<div></div>);
    }
};

export default Package;